import homeIcon from "../../../assets/icons/sliderHome.svg";
import fileIcon from "../../../assets/icons/sliderFile.svg";
import backIcon from "../../../assets/icons/back-icon.svg";
import "./DashboardMain.css";
import DashboardModelsCard from "./DashboardModelsCard/DashboardModelsCard";
import UploadOption from "../UploadOption/UploadOption";
import { useEffect, useState } from "react";
import DashboardHome from "./DashboardModelsCard/DashboardHome";
import { TranslatedConstants } from "../../../utilities/Constants/TranslateConstants";
import { ActiveModalProvider, ModalContainerProvider } from "../../../utilities/Models/modelUtils";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import ChatHistoryTable from "../ChatHistory/ChatHistoryTable";
import ConnectionModel from "./DashboardModelsCard/ConnectionModel";
import { useSelector } from "react-redux";

const DashboardMain = () => {
  const { activeCard } = useSelector(
    (state: any) => state.static
  );
  // const [activeButton, setActiveButton] = useState(0);
  // const [transitionState, setTransitionState] = useState("idle");
  // const [direction, setDirection] = useState("down");
  // const [prevComponent, setPrevComponent] = useState<number | null>(null);
  const { uploadOptions } = TranslatedConstants();
  const [showChatHistory, setShowChatHistory] = useState(false);
  const { t } = useTranslation('common');
  const sliderIcons = [
    { id: 0, icon: homeIcon, alt: "Home" },
    // { id: 1, icon: fileIcon, alt: "File" },
    /* { id: 2, icon: videoIcon, alt: "Video" }, */
  ];

  // const handleButtonClick = (index: number, scrollDirection: "up" | "down") => {
  //   if (index === activeButton || transitionState !== "idle") return;

  //   setDirection(scrollDirection);
  //   setPrevComponent(activeButton);
  //   setTransitionState("out");

  //   setTimeout(() => {
  //     setActiveButton(index);
  //     setTransitionState("in");
  //   }, 800);

  //   setTimeout(() => {
  //     setTransitionState("idle");
  //     setPrevComponent(null);
  //   }, 1600);
  // };

  // const handleWheel = (event: any) => {
  //   if (transitionState !== "idle") return;

  //   const scrollDirection = event.deltaY > 0 ? "down" : "up";
  //   const direction = event.deltaY > 0 ? 1 : -1;
  //   const newIndex = activeButton + direction;

  //   if (newIndex >= 0 && newIndex < sliderIcons.length) {
  //     handleButtonClick(newIndex, scrollDirection);
  //   }
  // };

  // useEffect(() => {
  //   const check = sessionStorage.getItem("new_user");
  //   if (check === "false") {
  //     setActiveButton(1);
  //   }
  // }, []);

  // const getComponentClass = (isCurrentComponent: boolean) => {
  //   if (transitionState === "idle") return "slide-component";

  //   if (isCurrentComponent) {
  //     if (transitionState === "out") {
  //       return `slide-component slide-exit-${direction}`;
  //     }
  //     return `slide-component slide-enter-${direction}`;
  //   }

  //   return `slide-component ${prevComponent !== null ? `slide-prev-${direction}` : ""}`;
  // };

  const toggleChatHistory = () => {
    setShowChatHistory(!showChatHistory);
  };

  return (
    <ModalContainerProvider>
      <ActiveModalProvider>
        <div className="row g-2">
          <div className="col-md-9">
            {/* onWheel={handleWheel} */}
              <div className="dashboard-main-card"  style={{ display: activeCard === "semanticModel-modal" ? 'none' : 'block' }}>
                {/* Chat History Controls */}
                <div className="chat-history-controls">
                  {/* <Button
                  className={`viewChatHistoryBtn ${showChatHistory ? 'hidden' : 'visible'}`}
                  onClick={toggleChatHistory}
                >
                  {t('viewchathistory')}
                </Button> */}
                  <Button
                    className={`backBtn ${showChatHistory ? 'visible' : 'hidden'}`}
                    icon={<img src={backIcon} alt="Back" />}
                    onClick={toggleChatHistory}
                  >
                    {t('buttons.back')}
                  </Button>
                </div>
                <div className="dashboard-content-wrapper">
                  {/* <div className="slider-icons-wrapper">
                    {sliderIcons.map((iconItem, index) => (
                      <button
                        key={iconItem.id}
                        className="slider-button active"
                        // className={`slider-button ${activeButton === index ? "active" : ""}`}
                        // onClick={() => handleButtonClick(index, index > activeButton ? "down" : "up")}
                      >
                        <img src={iconItem.icon} alt={iconItem.alt} />
                      </button>
                    ))}
                  </div> */}
                  {/* <div className="slides-container">
                    {prevComponent !== null && (
                      <div className={getComponentClass(false)}>
                        <div className="col-md-9">
                          {prevComponent === 0 && <DashboardHome />}
                          {prevComponent === 1 && <DashboardModelsCard />}
                          {prevComponent === 2 && <DashboardVideo />}
                        </div>
                      </div>
                    )}
                    <div className={getComponentClass(true)}>
                      <div className="col-md-9">
                        {activeButton === 0 && <DashboardHome />}
                        {activeButton === 1 && <DashboardModelsCard />}

                        {activeButton === 2 && <DashboardVideo />}

                      </div>
                    </div>
                  </div> */}
                   <div className="slides-container">
                    <div className="slide-component">
                      <div className="col-md-9" style={{ display: activeCard? 'none' : 'block' }}>
                        <DashboardHome />
                      </div>
                    </div>
                  </div>
                </div>
                {/* Chat History */}
                <div className={`chat-history-container ${showChatHistory ? 'show' : 'hide'}`}>
                  <ChatHistoryTable
                    visible={showChatHistory}
                    onClose={() => setShowChatHistory(false)}
                    chatHistory={[]}
                  />
                </div>
              </div>
            {activeCard === "semanticModel-modal" &&
              <div className="dashboard-Left-container d-flex justify-content-center w-100">
                <ConnectionModel connectionType={activeCard} />
              </div>
            }
          </div>
          <div className="col-md-3 main-card-dashboard">
            <div className="row g-2 flex-column " style={{ height: "calc(100vh - 26px)", flexWrap: "nowrap" }}>
              {uploadOptions.map((item: any, index: number) => (
                <div className="col-md-4 w-100" key={index}>
                  <UploadOption option={item} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </ActiveModalProvider>
    </ModalContainerProvider>
  );
};

export default DashboardMain;